export default __webpack_public_path__ + "static/media/ic-warning.c5abffff.svg";